import React, { useEffect, useRef } from "react";
import styles from "./PDFPreview.module.scss";
import classNames from "classnames";

// import { getDocument } from "pdfjs-dist";
// import {workerSrc} from "pdfjs-dist/build/pdf.worker.min.mjs";
// import * as pdfjsLib from "pdfjs-dist";
// import "pdfjs-dist/web/pdf_viewer.css";

// Set the worker to the CDN version (recommended for frontend apps)
// pdfjsLib.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

// // Point to worker in public folder (as you already did)
// GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/src/Page/AnnotationLayer.css";
import "react-pdf/src/Page/TextLayer.css";

const PDFPreview = ({ url, classname }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

  // const canvasRef = useRef(null);
  // const containerWidth = 320; // 10rem = 160px
  // const containerHeight = 160; // 6rem = 96px

  useEffect(() => {
    if (!url) return;

    // getDocument(url)
    //   .promise.then((pdf) => pdf.getPage(1))
    //   .then((page) => {
    //     const viewport = page.getViewport({ scale: 0.5 });

    //     // Calculate scale to fit within 10rem x 6rem while keeping aspect ratio
    //     const xScale = containerWidth / viewport.width;
    //     const yScale = containerHeight / viewport.height;
    //     const scale = Math.min(xScale, yScale); // maintain aspect ratio

    //     const scaledViewport = page.getViewport({ scale });

    //     const canvas = canvasRef.current;
    //     const context = canvas.getContext("2d");
    //     canvas.width = scaledViewport.width;
    //     canvas.height = scaledViewport.height;

    //     page.render({
    //       canvasContext: context,
    //       viewport: scaledViewport,
    //     });
    //   })
    //   .catch((err) => {
    //     console.error("PDF load error:", err);
    //   });
  }, [url]);

  return (
    <div className={classNames(styles.pdf_container, classname)}>
      {/* <canvas ref={canvasRef} style={{ display: "block" }} /> */}
      <Document file={url}>
        <Page
          className={styles.pdf_page}
          pageNumber={1}
          height={250}
          scale={1.75}
          // width={150}
          renderMode="canvas"
          onClick={() => {
            window.open(url, "_blank");
          }}
        />
      </Document>
    </div>
  );
};

export default PDFPreview;
